// extracted by mini-css-extract-plugin
module.exports = {"root":"SettingsDeletedPatients_root__N7R1G"};